import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { bulkEditExecutionDateOfServiceRequest, executionDateTicketMilestone } from '../../../actions/service_request';
import RenderMilestones from '../components/RenderMileStones';
import { useForm } from 'react-hook-form';
import Form from '../../../common/Form';
import MultiSelectDatePicker from '../../../common/Form/MultiDatePicker';
import RenderRemarksInput from '../../../components/Inputs/RenderRemarksInput';
import { actualValueForDropdown, ScogoID } from '../../../utils/common';
import MultiSelectDateTimePicker from '../../../common/Form/MultiSelectDateTimePicker';

export const formName = 'siteCompleteForm';

const BulkEditExecutionDate = ({ milestone_ids, org_id }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector(state => state.loading.formButtonLoading);
    const { newLoggedUserData } = useSelector(state => state.auth);
    const isScogoOrg = newLoggedUserData?.org?.id === ScogoID;

    const methods = useForm({ defaultValues: {}, mode: 'all' });

    const handleSubmit = (formValues) => {
        const payload = { dates: formValues.dates, milestone_ids };

        if (formValues.remark?.value) {
            payload.remark = formValues.remark.label;
            if (!formValues.remark.value.startsWith('create_this_issue')) {
                payload.master_remark_id = formValues.remark.value;
            }
        }

        dispatch(bulkEditExecutionDateOfServiceRequest({ formName, payload }));
    };

    return (
        <div className="px-6 py-4 relative overflow-hidden">
            <div className='w-full'>
                <Form
                    className='w-full'
                    methods={methods}
                    onSubmit={handleSubmit}
                    showSubmit
                    isLoading={formButtonLoading[formName]}
                    onCancel={() => dispatch(closeModalAction())}
                    submitContainerClassName='flex gap-2 justify-end py-4 px-4 relative'
                >
                    <div className='grid grid-cols-2 gap-4'>
                        <MultiSelectDateTimePicker required name='dates' label='Execution Dates' minDate={isScogoOrg ? undefined : new Date()} />
                        <RenderRemarksInput org_id={org_id} required name='remark' label='Remarks' category={'EXECUTION_DATE_CHANGE'} />
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default BulkEditExecutionDate;
